import * as React from "react";
const SvgArrow2 = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M19 12 5 20l4.17-8L5 4l14 8Z" }));
export default SvgArrow2;
